import { useTypedParams } from '@sorare/routing';

import { NoCardEntryCancel as CancelLineupForm } from '#src/components/noCardRoute/CancelLineupForm/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const NoCardEntryCancel = () => {
  const { so5LineupId } = useTypedParams<PageParams>();

  return <CancelLineupForm so5LineupId={so5LineupId} />;
};

export default NoCardEntryCancel;
